import React from "react";
import Formsy from "formsy-react";
import FormSelect from "../discover/common/controls/Select";
import Constants from "../../configurations/constants";

class ReportsSearch extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(data) {
    if (data.reportType) {
      this.props.onSearchHandler(data, true);
    }
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <Formsy
            onChange={this.handleChange}
            ref="discoverCaseFilter"
            noValidate
          >
            <div className="row">
              <div className="col-sm-10">
                <div className="row">
                  <div className="col-md-4">
                    <FormSelect
                      name="reportType"
                      label="Report Type"
                      options={Constants.REPORT_TYPES}
                      valueKey="value"
                      labelKey="label"
                    />
                  </div>
                  <div className="col-md-4">
                    <FormSelect
                      name="reportStatus"
                      label="Status"
                      options={Constants.REPORT_STATUS}
                      valueKey="value"
                      labelKey="label"
                    />
                  </div>
                </div>
              </div>
              {/*  <div className="col-md-2">
                <button
                  className="btn btn-primary btn-block mt-20"
                  type="submit"
                >
                  Search
                </button>
              </div> */}
            </div>
          </Formsy>
        </div>
      </div>
    );
  }
}

export default ReportsSearch;



// WEBPACK FOOTER //
// ./src/components/reports/ReportsSearch.js